import { ButtonVariant, ButtonTone } from '@design-system/atoms/button/button.types';
import { useTheme } from '@emotion/react';

export const useButtonIconColor = (
  variant: ButtonVariant,
  tone: ButtonTone = 'default',
  isLoading: boolean,
  isDisabled: boolean
) => {
  const theme = useTheme();

  if (isDisabled || isLoading) {
    return theme.colors.technical.gray[15];
  }

  // Handle neutral tone for all variants
  if (tone === 'neutral') {
    return theme.colors.technical.black;
  }

  if (variant === 'secondary' || variant === 'text') {
    switch (tone) {
      case 'error':
        return theme.colors.status.error.dark;
      case 'warning':
        return theme.colors.status.warning.dark;
      case 'info':
        return theme.colors.status.info.dark;
      default:
        return theme.colors.primary.normal;
    }
  }

  // Always return white color for primary variant (except neutral tone)
  return theme.colors.technical.white;
};
